const cartTokenLSKey = "cart_token";
const getCartToken = () => {
  return localStorage.getItem(cartTokenLSKey);
};
const setCartToken = (value) => {
  localStorage.setItem(cartTokenLSKey, value);
};
const removeCartToken = () => localStorage.removeItem(cartTokenLSKey);
const defaultCart = {
  id: "",
  items: [],
  priceSummary: [
    {
      name: "T\u1ED5ng ti\u1EC1n",
      value: "0\u0111"
    },
    {
      name: "Th\xE0nh ti\u1EC1n",
      value: "0\u0111"
    }
  ],
  grandTotalAmount: 0,
  paidAmount: 0,
  remainingAmount: 0,
  onDemandDiscount: 0,
  allowedUserActions: [],
  promotions: [],
  paymentMethods: [],
  orderTerminalCode: ""
};

export { defaultCart, getCartToken, removeCartToken, setCartToken };
